import React, { useEffect, useState } from "react";
import DefaultLayout from "../../layouts/defaultLayout";
import { userData } from "../../data/fake_login_data";
import { ToastContainer, toast } from "react-toastify";
import { Loader } from "rsuite";
import axios from "axios";
import { BASE_URL } from "../../constants";
import { useLocation, useSearchParams } from "react-router-dom";

const StudentProfile = () => {
  const location = useLocation();
  const [data, setData] = useState(null);
  const [courses, setCourses] = useState(null);
  const [chapters, setChapters] = useState(null);
  const [loading, setLoading] = useState(false);
  const [param, setParam] = useSearchParams();

  const fetchData = async () => {
    setLoading(true);

    try {
      const response = await axios.post(
        BASE_URL + "students/select_st_profile.php",
        {
          admin_id: userData?.user_id,
          access_token: userData?.access_token,
          student_id: param.get("stu_id"),
          type: "id",
        }
      );
      if (response?.data?.status === "success") {
        setData(response?.data?.message);
      } else toast.error("Student Not Found");
      setLoading(false);
    } catch (err) {
      setData([]);
      toast.error(err?.message);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    setChapters(
      data?.subscriptions?.filter((item) => item?.sub_type === "chapter")
    );
    setCourses(
      data?.subscriptions?.filter((item) => item?.sub_type === "course")
    );
  }, [data]);

  return (
    <div id="home" className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
      <DefaultLayout
        children={
          <div className="max-w-9xl mx-auto bg-white rounded-2xl shadow-xl p-8">
            <h4 className="text-2xl font-bold text-indigo-800 mb-6 text-center">Student Profile</h4>
            
            {loading ? (
              <div className="flex justify-center items-center h-40">
                <Loader size="lg" />
              </div>
            ) : (
              <>
                {data && (
                  <div className="flex flex-col md:flex-row items-center gap-6 mb-8 bg-indigo-50 p-6 rounded-xl shadow-md">
                    <img
                      src={
                        data?.student_photo && data?.student_photo?.length
                          ? data?.student_photo
                          : "https://camp-coding.tech/dr_elmatary/profile_icons/1032037.png"
                      }
                      alt="Student"
                      className="w-32 h-32 rounded-full object-cover border-4 border-indigo-500 shadow-lg"
                    />
                    <div className="text-center md:text-left">
                      <h2 className="text-xl font-bold text-indigo-700">
                        {data?.student_name} - {data?.uni_name} - {data?.grade_name}
                      </h2>
                      <p className="text-gray-600">{data?.student_email}</p>
                      <p className="text-gray-600">{data?.student_phone}</p>
                    </div>
                  </div>
                )}

                <div className="mb-10">
                  {data ? (
                    <div className="overflow-x-auto rounded-lg shadow-md">
                      <table className="min-w-full divide-y divide-gray-200">
                        <tbody className="bg-white divide-y divide-gray-200">
                          {data
                            ? Object.keys(data)?.map((item) => {
                                if (item != "subscriptions")
                                  return (
                                    <tr key={item} className="hover:bg-indigo-50 transition duration-200">
                                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900 capitalize">
                                        {item.replace(/_/g, ' ')}
                                      </td>
                                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                        <span>{data[item]}</span>
                                      </td>
                                    </tr>
                                  );
                              })
                            : null}
                        </tbody>
                      </table>
                    </div>
                  ) : null}
                </div>

                <h2 className="text-2xl font-bold text-indigo-800 mb-4">Subscription Courses</h2>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-10">
                  {courses && courses?.length ? (
                    courses?.map((item, index) => {
                      return (
                        <div
                          key={index}
                          className="bg-white rounded-xl shadow-lg overflow-hidden transition duration-300 hover:shadow-xl hover:scale-105"
                        >
                          <img
                            src={
                              item?.course_details?.course_photo &&
                              item?.course_details?.course_photo?.length
                                ? item?.course_details?.course_photo
                                : "https://elmatary.com/El_Matary_Platform/platform/admin/images/225557437_1693865054item_img.jpeg"
                            }
                            alt="Course"
                            className="w-full h-40 object-cover"
                          />
                          <div className="p-4">
                            <h5 className="text-lg font-bold text-indigo-700 mb-2">
                              Course: {item?.course_details?.course_name}
                            </h5>
                            <p className="text-sm text-gray-600 mb-4">
                              Subscription date: {item?.date}
                            </p>
                            {/* <button className="w-full px-4 py-2 bg-red-500 text-white font-bold rounded-md shadow hover:bg-red-600 transition duration-200">
                              Cancel Subscription
                            </button> */}
                          </div>
                        </div>
                      );
                    })
                  ) : (
                    <h4 className="col-span-3 text-center text-gray-600">No Subscriptions</h4>
                  )}
                </div>

                <h2 className="text-2xl font-bold text-indigo-800 mb-4">Subscription Chapters</h2>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                  {chapters && chapters?.length ? (
                    chapters?.map((item, index) => {
                      return (
                        <div
                          key={index}
                          className="bg-white rounded-xl shadow-lg overflow-hidden transition duration-300 hover:shadow-xl hover:scale-105"
                        >
                          <img
                            src={
                              item?.chapter_details?.chapter_photo &&
                              item?.chapter_details?.chapter_photo?.length
                                ? item?.chapter_details?.chapter_photo
                                : "https://elmatary.com/El_Matary_Platform/platform/admin/images/225557437_1693865054item_img.jpeg"
                            }
                            alt="Chapter"
                            className="w-full h-40 object-cover"
                          />
                          <div className="p-4">
                            <h5 className="text-lg font-bold text-indigo-700 mb-2">
                              Chapter: {item?.chapter_details?.chapter_title}
                            </h5>
                            <p className="text-sm text-gray-600 mb-4">
                              Subscription date: {item?.date}
                            </p>
                            {/* <button className="w-full px-4 py-2 bg-red-500 text-white font-bold rounded-md shadow hover:bg-red-600 transition duration-200">
                              Cancel Subscription
                            </button> */}
                          </div>
                        </div>
                      );
                    })
                  ) : (
                    <h4 className="col-span-3 text-center text-gray-600">No Subscriptions</h4>
                  )}
                </div>
              </>
            )}
          </div>
        }
      />
      <ToastContainer />
    </div>
  );
};

export default StudentProfile;